import { createContext, useContext } from 'react';
import type { ReactNode } from 'react';
import { useFileService } from '../../hooks/useFileService';
import { useTabs } from './TabsContext';

export const FileServiceContext = createContext({
  downloadCsvFile: (..._args: any) => {},
  downloadFileFromUrl: (..._args: any) => {},
});

export const useFileServiceContext = () => {
  return useContext(FileServiceContext);
};

export const FileServiceContextProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const { activeGlobalTab } = useTabs();

  const { downloadCsvFile, downloadFileFromUrl } = useFileService({
    tabId: activeGlobalTab.id,
  });

  return (
    <FileServiceContext.Provider
      value={{
        downloadCsvFile,
        downloadFileFromUrl,
      }}
    >
      {children}
    </FileServiceContext.Provider>
  );
};
